import { webKnots } from 'src/features/brands/dxm/canvas/common/back/lace/webKnots'
import { webToCatchFaceConnect } from '../lace/webToCatchFaceConnect'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'
import { lacePartsOfWeb1, lacePartsOfWeb2, upRightDownLeft } from './parts/laceParts'

export const wi10Web = (ctx: CanvasRenderingContext2D, webColor: string, edgeColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(627, 117) //左上
  ctx.quadraticCurveTo(607, 176, 571, 220) //左下
  ctx.quadraticCurveTo(591, 240, 607, 280) //右下
  ctx.quadraticCurveTo(658, 233, 672, 184) //右上
  ctx.quadraticCurveTo(650, 141, 627, 115) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ヘリ革パーツ
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(627, 115) //左上
  ctx.quadraticCurveTo(607, 176, 571, 220) //左下
  ctx.quadraticCurveTo(577, 227, 577, 227) //右下
  ctx.quadraticCurveTo(614, 183, 634, 124) //右上
  ctx.quadraticCurveTo(627, 117, 627, 115) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.moveTo(667, 172) //左上
  ctx.quadraticCurveTo(645, 235, 603, 269) //左下
  ctx.quadraticCurveTo(607, 280, 607, 280) //右下
  ctx.quadraticCurveTo(658, 233, 672, 184) //右上
  ctx.quadraticCurveTo(667, 172, 667, 172) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // // 縦向き＿左
  ctx.moveTo(649, 144) // 上
  ctx.quadraticCurveTo(625, 201, 590, 244) // 下
  // // 縦向き＿右
  ctx.moveTo(653, 150) // 上
  ctx.quadraticCurveTo(626, 213, 595, 248) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  webToCatchFaceConnect(ctx, laceColor, 30, 53, 0.9)
  halfLace(ctx, laceColor, -60, -180)

  // 横向きレース
  ctx.moveTo(590, 224)
  ctx.quadraticCurveTo(605, 234, 612, 251)
  ctx.quadraticCurveTo(620, 246, 620, 246)
  ctx.quadraticCurveTo(613, 225, 593, 214)
  ctx.quadraticCurveTo(590, 224, 590, 224)
  ctx.fill()
  ctx.moveTo(591, 221)
  ctx.quadraticCurveTo(610, 235, 614, 249)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  webKnots(ctx, laceColor, 25, -54) // ウェブ先端寄りのウェブ結び目
  webKnots(ctx, laceColor, -50, 45) // 捕球面寄りのウェブ結び目
}

const halfLace = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  // 左
  lacePartsOfWeb1(ctx, laceColor, 68 + x, 175 + y, 1, 1) //
  upRightDownLeft(ctx, laceColor, 120 + x, 70 + y)
  lacePartsOfWeb1(ctx, laceColor, 58 + x, 194 + y, 1, 1) //
  // // 右
  lacePartsOfWeb2(ctx, laceColor, 103 + x, 65 + y, 10, 1)
  lacePartsOfWeb2(ctx, laceColor, 90 + x, 85 + y, 10, 1)
  upRightDownLeft(ctx, laceColor, 200 + x, 170 + y)
}
